import {HTTP} from '@/router/http';
import Vue from 'vue'
// initial state
const state = {
	pis:[],
	all: [],
	current: {
		user_id: null,
		username: null,
		authdata: null,
		jwt: null,
		permissions: null,
		role: null,
		validator: null
	}

}

// getters
const getters = {
	allUsers: state => state.all,
	users: state => state.all,
	pis: state => state.pis,
	currentUser: state => state.current
}

// actions
const actions = {
	getAllUsers ({ commit }) {
		return HTTP.get('/user').then(res => {
			commit('SET_USERS', res.data)
			return res.data
		});
	},
	getPis ({ commit }) {
		return new Promise((resolve, reject) => {
			HTTP.get('/pis').then(res => {
				commit('SET_PIS', res.data)
				resolve(res.data)
			}).catch(err => reject(err));
		})
	},
	deletePi ({ commit },pi_id) {
		return new Promise((resolve, reject) => {
			HTTP.delete('/pi/'+pi_id).then( () => {
				commit('DELETE_PI', pi_id)
			}).catch(function(err){
				reject(err)
			});
		})
	},
	updatePi ({ commit },pi) {
		HTTP.put('/pi',pi).then(res => {
			commit('UPDATE_PI', res.data)
		});
	},
	addPi ({ commit },pi) {
		HTTP.post('/pi',pi).then(res => {
			commit('ADD_PI', res.data)
		});
	},
	register ({ commit },user){
		return new Promise((resolve, reject) => {
			HTTP.post('user',user).then(res => {
				var userData = res.data;
				var loggedUser = {
					user_id: userData.user_id,
					username: userData.username,
					firstname: userData.firstname,
					lastname: userData.lastname,
					authdata: userData.code,
					jwt: userData.jwt,
					permissions: userData.permissions,
					role: userData.role,
					validator: userData.validator
				}
				commit("LOGIN",loggedUser);
				resolve(loggedUser);
			})
				.catch(function(err){reject(err)})
		})
	},
	login ({ commit }, user) {
		return new Promise((resolve, reject) => {
			HTTP.post('/authenticate', user)
				.then(function(res){
				
					var userData = res.data;
				
					// google authenticator // 
					var loggedUser;
					if (userData.ga_status !== undefined){
						loggedUser = {
							user_id: userData.user_id,
							username: userData.login,
							qr_img_src: userData.qr_img_src,
							ga_status: userData.ga_status
						};
						resolve(userData);
						return;
					}
					var authdata = userData.code;
					HTTP.defaults.headers.common['authorization'] = 'Bearer '+userData.jwt;
					loggedUser = {
						user_id: userData.user_id,
						username: userData.login,
						authdata: authdata,
						jwt: userData.jwt,
						permissions: userData.permissions,
						role: userData.role
					};
					localStorage.setItem('currentUser',JSON.stringify(loggedUser));
					commit('LOGIN',loggedUser);
					resolve(userData);
				})
				.catch(function (err) { reject(err) })
		})
	},
	loginGA ({ commit }, user) {
		return new Promise((resolve, reject) => {
			HTTP.post('/ga_authenticate', user)
				.then(function(res){
				
					var userData = res.data;
					var loggedUser;
					// google authenticator // 
				
					if (userData.ga_status !== undefined){
						loggedUser = {
							user_id: userData.user_id,
							username: userData.login,
							qr_img_src: userData.qr_img_src,
							ga_status: userData.ga_status
						};
						resolve(userData);
						return;
					}
				
					var authdata = userData.code;
					HTTP.defaults.headers.common['authorization'] = 'Bearer '+userData.jwt;
					loggedUser = {
						user_id: userData.user_id,
						username: userData.login,
						authdata: authdata,
						jwt: userData.jwt,
						permissions: userData.permissions,
						role: userData.role
					};
					localStorage.setItem('currentUser',JSON.stringify(loggedUser));
					commit('LOGIN',loggedUser);
					resolve(userData);
				})
				.catch(function (err) { reject(err) })
		})
	},
	getCredentials({ commit }){
		if (state.current.user_id){
			return state.current
		}
		else {
			let user = localStorage.getItem('currentUser');
			if (user){
				user = JSON.parse(user);
				if (user.jwt){
					// var parts = Base64.decode(user.authdata).split(":");
					// HTTP.defaults.auth = {username: parts[0],password: parts[1]};
					HTTP.defaults.headers.common['authorization'] = 'Bearer '+user.jwt;
				}
				commit('LOGIN',user);
				return true;
			}
			else {
				return false;
			}
		}
	},
	checkPermissions(ctx,params){
		let permissionsToCheck = params.permissions
		let condition = params.condition
		if (condition != 'all') condition = 'any';
		if (!state.current.permissions) return (permissionsToCheck.substr(0,1) === '!') ? true : false;
		if (condition == 'any'){
			return (permissionsToCheck.substr(0,1) === '!') ? !state.current.permissions.some(v => permissionsToCheck.includes(v)) : state.current.permissions.some(v => permissionsToCheck.includes(v));
		} 
		else if (condition == 'all') return _.difference(permissionsToCheck, state.current.permissions).length === 0;
		return false;
	},
	logout ({ commit }){
		localStorage.removeItem('currentUser');
		HTTP.defaults.headers.common['authorization'] = ''
		commit('LOGOUT');
	},
	getMonthVacations(ctx, params) {
		return HTTP.get("user/vacations",{params: params}).then(res => {
			return res.data
		})
	},
	getUserMontlyActivity ({ commit },params) {
		return HTTP.get('user/activities?year='+params.year).then(res => {
			commit("SET_ACTIVITIES",res.data)
			return res.data
		})
	},
	getUserMontlyInvoicedActivity ({ commit },params) {
		return HTTP.get('user/invoiced_activities?year='+params.year).then(res => {
			commit("SET_INVOICED_ACTIVITIES",res.data)
			return res.data
		})
	},
	updateWorkPercent ({ commit }, params) {
		let users = params.users
		let year = params.year
		let updates = []
		for (let i = 0; i < users.length; i++) {
			for (let j = 0; j < 12; j++){
				if (state.all[i].activities[j].percent_work != users[i].activities[j].percent_work) {
					updates.push({
						user_id: users[i].user_id,
						month: (j+1),
						percent_work: users[i].activities[j].percent_work,
						year: year
					})
				}
			}
		}
		if (updates.length) {
			return HTTP.patch("users",updates).then( res => {
				commit("SET_PERCENT_WORK",res.data)
				return res.data
			})
		}
	}


}

// mutations
const mutations = {
	SET_USERS (state, users) {
		state.all = users
	},
	SET_PIS (state, pis) {
		state.pis = pis
	},
	SET_INVOICED_ACTIVITIES (state, data) {
		_.forEach(state.all, (u,uidx) => {
			state.all[uidx].invoiced_activities = []
			if (data[u.user_id]) {
				state.all[uidx].invoiced_activities = data[u.user_id]
			}
		})
	},
	SET_ACTIVITIES (state, data) {
		_.forEach(state.all, (u,uidx) => {
			if (data[u.user_id]) {
				state.all[uidx].activities = data[u.user_id]
			}
		})
	},
	SET_PERCENT_WORK (state, data) {
		_.forEach(state.all, (u,uidx) => {
			_.forEach(data, user => {
				if (u.user_id === user.user_id) {
					state.all[uidx].activities[(user.month-1)].percent_work = +user.percent_work
				}
			})
		})
	},
	ADD_PI (state, pi) {
		state.pis.push(pi)
	},
	DELETE_PI (state, pi_id) {
		var piidx = _.findIndex(state.pis,function(p){return p.pi_id == pi_id;})
		if (piidx>-1){
			state.pis.splice(piidx,1);
		}
	},
	UPDATE_PI (state, pi) {
		var piidx = _.findIndex(state.pis,function(p){return p.pi_id == pi.pi_id;})
		if (piidx>-1){
			Vue.set(state.pis,piidx, pi);
		}
	},
	LOGIN (state, user){
		state.current = user;
	},
	LOGOUT (state){
		state.current = {
			user_id: null,
			username: null,
			authdata: null,
			jwt: null,
			permissions: null,
			role: null,
			validator: null
		}

	}
}

export default {
	state,
	getters,
	actions,
	mutations
}